<div *ngIf="htmlElement.htmlSelectElementHolder">
  <app-html-select-element [htmlSelectElement]="htmlElement.htmlSelectElementHolder" [formGroup]="formGroup"></app-html-select-element>
</div>
